/**
 * Service to check if a word matches our bad words list.
 */
angular.module('tgaApp').service('badWordsFilterService', ['badWordList',
  function (badWordList) {
    /* simply check if the word matches anything on the list */
    this.checkWord = (str) => {
      if (str === null || angular.isUndefined(str)) {
        return false;
      }
      const s = str.toLowerCase().replace(/[-_\s]/g, '');
      for (let i = 0; i < badWordList.length; i++) {
        if (s === badWordList[i].replace(/[-\s]/g, '')) {
          return true;
        }
      }
      return false;
    };
  },
]);
